import { gql } from "@apollo/client";

export const GET_CUIDADOS_DOMICILIARIOS_RI_BY_ID = gql`
query CuidadosDomiciliariosRIByID (
    $idDatosGenerales: Int!
) {
    cuidadosDomiciliariosRIById (
        idDatosGeneralesRI: $idDatosGenerales
    ){
        cuidadosDomiciliariosRI{
            idDatosGeneralesRI
            idCuidadosDomiciliariosRI
            sNC
            cV
            respiratorio
            digestivo
            videodeglucion
            otros
            traqueostomia
            sondaVesical
            ostomia
            cateter
            sondaNasogastrica
            idComboRIValorCalendarioVacunas
            idComboRIValorAduKarnofsky
            idComboRIValorPedLANSKY
            requiereSoporteNutricional
            idCuidadosDomiciliariosRI
            idComboRIValorTabaquismo
            antecedentesAlcoholismo
            antecedentesConsumoSustancias
            tipoSustancia
            infusionDrogas
            drogasAInfundir
            dosis
            frecuencia
            cumpleCriterioIngreso
            infusionesPrevias
            cuantas
            donde
            reaccionesAdversas
        }
        videodeglucionAdjunto {
            contentType
            titulo
            archivo
            extension
        }
    }
}`;